<script>
export default {
  name: "HomePage",
  components: {}
};
</script>
<style scoped lang="scss"></style>
